import { Alert, Stack } from "@mui/material";
import { SellingField, StepHeading } from "./FormFields";

export default function PricingStep() {
  return (
    <>
      <StepHeading title="Set Your Price">
        Choose an asking price for one toy. Your earnings estimate updates as
        you type.
      </StepHeading>
      <Stack spacing={3}>
        <SellingField
          name="price"
          label="Price (USD)"
          required
          money
          suffix="USD"
          placeholder="0.00"
        />
        <SellingField
          name="minimumOffer"
          label="Lowest Offer You'll Consider (optional)"
          money
          suffix="USD"
          helper="Must be positive and no higher than your asking price."
        />
        <Alert severity="info">
          You can record a minimum offer here. Buyer offers and negotiations
          will be connected separately.
        </Alert>
      </Stack>
    </>
  );
}
